import { ScmType } from "@protos/common/v1/common";

import { getPullRequestNumber, isPullRequest } from "../gitUtils";
import { trimPath } from "../trimPath";

export const formatProviderRef = (
  origin: ScmType | undefined,
  ref: string,
  pullRequestId: number | undefined
) => {
  const nonPullRequestRef = `${trimPath(ref)}`;

  let formattedRef;
  switch (origin) {
    case ScmType.GITHUB:
    case ScmType.GITHUB_ENTERPRISE:
      if (isPullRequest(ref)) {
        formattedRef = `PR #${getPullRequestNumber(ref)}`;
      } else {
        formattedRef = nonPullRequestRef;
      }
      break;
    case ScmType.GITLAB:
    case ScmType.GITLAB_SELFMANAGED:
      if (pullRequestId) {
        formattedRef = `MR !${pullRequestId}`;
      } else {
        formattedRef = nonPullRequestRef;
      }
      break;
    case ScmType.BITBUCKET:
    case ScmType.BITBUCKET_DATACENTER:
      if (pullRequestId) {
        formattedRef = `PR #${pullRequestId}`;
      } else {
        formattedRef = nonPullRequestRef;
      }
      break;
    default:
      formattedRef = nonPullRequestRef;
  }
  // just in case there are trailing spaces
  return formattedRef.trim();
};
